module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Users/neenu.korula/AA/eventorg-web/src/app/common/authentication-layout/authentication-layout.component.html
// module id = ../../../../../src/app/common/authentication-layout/authentication-layout.component.html
// module chunks = main